import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import { removeRisk } from 'store/entities/risks/risks';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const RiskDeleteModal = ({ setModalVisible, removeRisk, riskId, projectId }) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    removeRisk(riskId, { projectId });
    setModalVisible(false);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(translations.risks_deleteRisk),
          content: <>{t(translations.risks_areYouSureYouWantToDeleteThisRisk)}</>,
          footer: (
            <>
              <Button testId="delete-modal-button-delete" label={t(translations.delete)} colored onClick={onDelete} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapDispatchToProps = { removeRisk };
const Container = withErrorBoundary(connect(null, mapDispatchToProps)(RiskDeleteModal), { isModal: true });

export { Container as RiskDeleteModal };
